import React from "react";
import HighlightCompanyName from "./HighlightCompanyName";

const CareersCTA = ({ content }) => {
  const handleSendResume = () => {
    const subject = "Career Enquiry - Belageri Technologies";

    const body = `Dear Belageri Technologies Hiring Team,

I am interested in exploring career opportunities at Belageri Technologies.

Please find my resume attached for your consideration.

Thank you.

Regards,
[Your Name]
[Phone Number]
[Email Address]`;

    const gmailUrl =
      `https://mail.google.com/mail/?view=cm&fs=1` +
      `&to=contactus@belageri.com` +
      `&su=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank");
  };

  return (
    <section className="careers-cta">
      <div className="careers-container">
        <div className="careers-cta__inner">
          <div className="careers-cta__content">
            <span className="section-heading__eyebrow">YOUR NEXT MOVE</span>

            <h2>{content.title}</h2>

            <p>
              <HighlightCompanyName text={content.description} />
            </p>
          </div>

          <button
            type="button"
            className="careers-cta__button"
            onClick={handleSendResume}
          >
            {content.button}

            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CareersCTA;
